import { IInteraction } from '@amc-technology/davinci-api';
import { CID } from '../Types/CID';

/**
 * Enum representing the type of event in the queue
 */
export enum EventQueueType {
  INTERACTION = 'interaction',
  PRESENCE = 'presence'
}

/**
 * Base event queue interface with common properties
 */
export interface IEventQueueBase {
  type: EventQueueType;
  timestamp: number;
  processId: CID;
}

/**
 * Interaction event in the queue
 */
export interface IEventQueueInteraction extends IEventQueueBase {
  type: EventQueueType.INTERACTION;
  interaction: IInteraction;
}

/**
 * Presence event in the queue
 */
export interface IEventQueuePresence extends IEventQueueBase {
  type: EventQueueType.PRESENCE;
  presence: string;
  reason?: string;
  initiatingApp?: string;
}

/**
 * Union type for all event queue items
 */
export type IEventQueue = IEventQueueInteraction | IEventQueuePresence;
